<div class="widgets">
  <div class="sr-widget sr-widget-1" #standardWidgetSIR></div>
</div>
